import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import { loadAnalytics } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useSearch } from "@ofqual/portal-core/core/hooks/useSearch";
import { useUrl } from "@ofqual/portal-core/core/hooks";
import { analyticsSelector } from "../../redux/selectors";
import { Skeleton } from "@material-ui/lab";
import { DashboardSection } from "./DashboardSection";
import { DashboardAppBar } from "./DashboardAppBar";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
    heading: {
      color: "#9f9f9f",
      fontSize: "1.2em",
      fontWeight: 600,
    },
    container: {
      justifyContent: "space-between",
    },
  };
});
export const Dashboard: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const analyticsState = useSelector(analyticsSelector);
  const { data, loadingState } = analyticsState;

  const { searchParams } = useSearch(useUrl());

  useEffect(() => {
    dispatch(loadAnalytics(searchParams));
  }, [dispatch, searchParams]);

  return (
    <div className={classes.root}>
      <DashboardAppBar />
      {loadingState === "LOADED" ? (
        <Grid container spacing={3}>
          {data.sections.map((section, index) => (
            <DashboardSection key={index} section={section} />
          ))}
        </Grid>
      ) : (
        <>
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <br />
          <Skeleton variant="rect" height={118} />
        </>
      )}
    </div>
  );
};
